const BASE = (import.meta.env.VITE_API_URL ?? "/api").replace(/\/$/, "");

export async function api<T = unknown>(
  path: string,
  init?: RequestInit
): Promise<{ ok: boolean; status: number; data: T | null; error?: string }> {
  const res = await fetch(`${BASE}${path}`, {
    credentials: "include",
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });

  let data: T | null = null;
  let error: string | undefined;
  try {
    const json = await res.json();
    if (res.ok) data = json as T;
    else error = (json && typeof json === "object" && "error" in json && typeof json.error === "string") ? json.error : `HTTP ${res.status}`;
  } catch {
    if (!res.ok) error = `HTTP ${res.status}`;
  }

  return { ok: res.ok, status: res.status, data, error };
}
